<template>
	<div v-if="contentFacetGroups.length" class="c-content-filters" data-testid="content-filters">
		<slot v-for="group in contentFacetGroups">
			<slot
				  v-for="facet in group.data">
				<label
					   v-if="!facet.items && facet.visible && facet.checked"
				       :key="`${facet.name}-label`"
					   :for="facet.name"
					   class="c-content-filters__tag">
					{{ facet.value }}
					<span class="c-content-filters__tag--close" />
				</label>
				<slot
					  v-else
					  v-for="item in facet.items"
					  >
					<label
						   v-if="item.visible && item.checked"
						   :key="`${item.name}-label`"
						   :for="item.name"
						   class="c-content-filters__tag">
						{{ item.value }} {{ facet.subGroupName }}
						<span class="c-content-filters__tag--close" />
					</label>
				</slot>
			</slot>
		</slot>
		<button v-if="Object.keys(activeLibraryFilters).length"
				class="c-content-filters__link"
				@click.prevent="resetFilters"
				@keydown.enter.prevent="resetFilters">
			{{ clearFiltersLabel }}
		</button>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';

	export default {
		name: 'content-filters',
		props: ['clearFiltersLabel'],
		computed: {
			...mapGetters({
				activeLibraryFilters: 'getActiveLibraryFilters',
				contentFacetGroups: 'getContentFacetGroups',
				visitorId: 'getVisitorID',
			}),
		},
		methods: {
			...mapActions(['resetContentFacetGroups']),
			resetFilters() {
				this.resetContentFacetGroups();
			},
		},
	};
</script>
